import moment from 'moment'
import {Card} from 'react-bootstrap'
import {STORAGE_NAMES} from '../helpers/consts'
import {useLazyQuery} from '@apollo/client'
import {useEffect, useRef, useState} from 'react'
import {
  ClientListEdge,
  EdgeVolcos,
  IResCanterasVentas,
  IResClientsVentas,
  IResProductsVentas,
  IResVolcosDispatch,
} from '../graphql/types/ventasType'
import {
  GET_CANTERAS_CREATE_DISPATCH,
  GET_CLIENTS_CREATE_DISPATCH,
  GET_NAMTRIK_FORM,
  GET_PRODUCTS_CREATE_DISPATCH,
  GET_VOLCOS_CREATE_DISPATCH,
} from '../graphql/queries/getDespachos'
import {IDataGetNamtrikForm} from '../graphql/types/despachoTypes'
import {useGetUser} from '../hooks/useGetUser'

export const RefetchData = () => {
  const {user} = useGetUser()
  const [
    gqlGetClients,
    {
      data: dataClients,
      loading: loadingClients,
      /* error: errorClients,
      networkStatus: networkStatusClients, */
    },
  ] = useLazyQuery<IResClientsVentas>(GET_CLIENTS_CREATE_DISPATCH, {fetchPolicy: 'no-cache'})
  const [
    gqlGetCanteras,
    {
      data: dataCanteras,
      loading: loadingCanteras,
      /* networkStatus: networkStatusCanteras,
      error: errorCanteras, */
    },
  ] = useLazyQuery<IResCanterasVentas>(GET_CANTERAS_CREATE_DISPATCH)
  const [
    gqlGetVolcos,
    {
      data: dataVolcos,
      loading: loadingVolcos,
      /* networkStatus: networkStatusVolcos,
      error: errorVolcos, */
    },
  ] = useLazyQuery<IResVolcosDispatch>(GET_VOLCOS_CREATE_DISPATCH)
  const [
    gqlGetProducts,
    {
      data: dataProducts,
      loading: loadingProducts,
      // networkStatus: networkStatusProducts,
      // error: errorProducts,
    },
  ] = useLazyQuery<IResProductsVentas>(GET_PRODUCTS_CREATE_DISPATCH)
  const [
    gqlGetNamtrikForm,
    {
      data: dataNamtrikForm,
      loading: loadingNamtrikForm,
      /* error: errorNamtrikForm,
      networkStatus: networkStatusNamtrikForm, */
    },
  ] = useLazyQuery<IDataGetNamtrikForm>(GET_NAMTRIK_FORM)

  const [dataLoad, setDataLoad] = useState(0)

  const totalArrClients = useRef<ClientListEdge[]>([])

  const totalArrVolcos = useRef<EdgeVolcos[]>([])

  useEffect(() => {
    if (!dataClients) return
    if (!user) return
    if (dataClients.clientList?.edges?.length > 0) {
      totalArrClients.current = [...totalArrClients.current, ...dataClients.clientList.edges]
      if (dataClients?.clientList?.pageInfo.hasNextPage) {
        console.log('dataClients', dataClients)
        gqlGetClients({
          variables: {
            statusSale: 'ABIERTA',
            after: dataClients.clientList.pageInfo.endCursor,
          },
        })
        return
      }
      localStorage.setItem(STORAGE_NAMES.CLIENTS, JSON.stringify(totalArrClients.current))
      setDataLoad((pre) => pre + 1)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataClients])
  useEffect(() => {
    if (!dataCanteras) return
    if (dataCanteras.quarryList?.edges?.length > 0) {
      const arr = dataCanteras.quarryList.edges.map(({node}) => ({
        value: node.id,
        label: node.name,
      }))
      localStorage.setItem(STORAGE_NAMES.CANTERAS, JSON.stringify(arr))
      setDataLoad((pre) => pre + 1)
    }
  }, [dataCanteras])
  useEffect(() => {
    if (!dataVolcos) return
    if (dataVolcos.transportList?.edges?.length > 0) {
      totalArrVolcos.current = [...totalArrVolcos.current, ...dataVolcos.transportList.edges]
      if (dataVolcos?.transportList?.pageInfo.hasNextPage) {
        console.log('dataVolcos', dataVolcos)
        gqlGetVolcos({
          variables: {
            after: dataVolcos.transportList.pageInfo.endCursor,
          },
          fetchPolicy: 'no-cache',
        })
        return
      }
      const arr = totalArrVolcos.current.map(({node}) => ({
        value: node.plate,
        label: node.plate,
        size: node.sizeVolco,
      }))
      localStorage.setItem(STORAGE_NAMES.VOLCOS, JSON.stringify(arr))
      setDataLoad((pre) => pre + 1)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataVolcos])
  useEffect(() => {
    if (!dataNamtrikForm) return
    if (dataNamtrikForm.getEntityForms.length === 0) return
    localStorage.setItem(STORAGE_NAMES.NAMTRIK_FORM, JSON.stringify(dataNamtrikForm.getEntityForms))
    setDataLoad((pre) => pre + 1)
  }, [dataNamtrikForm])
  useEffect(() => {
    if (!dataProducts) return
    if (dataProducts.productList?.edges?.length > 0) {
      const arr = dataProducts.productList.edges.map(({node}) => ({
        node: {
          id: node.id,
          units: Infinity,
          product: {
            id: node.id,
            unitType: node.unitType!,
            name: node.name,
            unitPrice: node.unitPrice,
          },
        },
      }))
      // setVolcosSelect(arr)
      localStorage.setItem(STORAGE_NAMES.PRODUCTS, JSON.stringify(arr))
      setDataLoad((pre) => pre + 1)
    }
  }, [dataProducts])
  useEffect(() => {
    if (dataLoad === 5) {
      localStorage.setItem(STORAGE_NAMES.DATE, new Date().toISOString())
      setDataLoad(0)
    }
  }, [dataLoad])

  const dateStorage = localStorage.getItem(STORAGE_NAMES.DATE)
  console.log('dateStorage', dateStorage)

  return (
    <div className='col-lg-12'>
      <Card>
        <Card.Body className='d-flex align-items-center justify-content-between'>
          <div>
            <i className='bi bi-clock fs-1' />
          </div>
          <div className='d-flex align-items-center gap-2'>
            <p className='p-0 m-0'>
              Ultima actualización -{' '}
              {dateStorage ? (
                moment(dateStorage).fromNow()
              ) : (
                <span className='text-danger'>Sin actualizar</span>
              )}
            </p>
            <button
              className='border-0 p-0 m-0 bg-transparent'
              onClick={() => {
                localStorage.setItem(STORAGE_NAMES.DATE, new Date().toISOString())

                setDataLoad(0)
                gqlGetClients({
                  variables: {
                    statusSale: 'ABIERTA',
                  },
                  fetchPolicy: 'network-only',
                })
                gqlGetCanteras({fetchPolicy: 'network-only'})
                gqlGetNamtrikForm({
                  variables: {
                    codename: 'CLIENTE',
                  },
                  fetchPolicy: 'network-only',
                })
                gqlGetVolcos({fetchPolicy: 'network-only'})
                gqlGetProducts({fetchPolicy: 'network-only'})
                totalArrClients.current = []
                totalArrVolcos.current = []
              }}
              disabled={loadingCanteras || loadingClients || loadingNamtrikForm || loadingProducts}
            >
              <i
                className={`fa fa-solid fa-rotate-right ${
                  loadingCanteras || loadingClients || loadingVolcos ? 'loading-refetch' : ''
                }`}
              />
            </button>
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}
